export { OncologyTestCardBase } from "./OncologyTestCardBase";
export { LatitudeTestCard } from "./LatitudeTestCard";
